import styled from "styled-components";
import { Image } from "antd";

export const ImageStyle = styled(Image)`
  object-fit: contain;
`;

export const StyledImg = styled.div`
  position: relative;
  &:hover .mark {
    opacity: 1;
  }
  .mark {
    position: absolute;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    color: #fff;
    opacity: 0;
    cursor: pointer;
  }
  img {
    object-fit: contain;
  }
`;
